import { Flex } from '@atlaskit/primitives';
import EntryLink from '@databases/content-link/EntryLink';
import { DatabaseFieldType } from '@databases/types/database';
import { MultiValueChangeType } from '@databases/utils/database/changesets';
import React, { type FC, useCallback } from 'react';

import { FieldValueRemoveButton } from '../popover-edit-common';
import { EditComponentProps } from '../types';

import type { EntryLinkReference } from './types';

interface EntryLinkValueProps extends EditComponentProps<DatabaseFieldType.ENTRY_LINK> {
  entryLinkValue: EntryLinkReference;
  contentId: string;
  isReadOnly: boolean;
  autoFocus?: boolean;
  addDataSectionRef: React.RefObject<HTMLDivElement>;
}

const preventDefault = (e: React.MouseEvent | React.FocusEvent) => {
  // Prevent propagation to inline edit
  e.stopPropagation();
};

export const EntryLinkValue: FC<EntryLinkValueProps> = ({
  entryLinkValue,
  contentId,
  isReadOnly,
  autoFocus,
  value: entryValues,
  addDataSectionRef,
  onChange,
}) => {
  const linkValueIndex = entryValues.findIndex(
    (value) => entryLinkValue._id !== '' && value._id === entryLinkValue._id
  );

  const onDeleteClick = useCallback(() => {
    onChange(entryValues, {
      type: DatabaseFieldType.ENTRY_LINK,
      delta: {
        type: MultiValueChangeType.REMOVE,
        index: linkValueIndex,
      },
    });

    if (addDataSectionRef.current) {
      addDataSectionRef.current?.getElementsByTagName('input')[0].focus();
    }
  }, [entryValues, addDataSectionRef, linkValueIndex, onChange]);

  return (
    <Flex testId={'entry-link-value'} alignItems={'center'}>
      <EntryLink
        entryRef={entryLinkValue}
        onClick={preventDefault}
        onFocus={preventDefault}
        contentId={contentId}
        isReadonly={isReadOnly}
      />
      <FieldValueRemoveButton
        testId={'entry-link-remove-button'}
        onItemDelete={onDeleteClick}
        autoFocus={autoFocus}
      />
    </Flex>
  );
};
